import { render } from "./CyanoDataMaterial.vue?vue&type=template&id=980ae3e4"
import script from "./CyanoDataMaterial.vue?vue&type=script&lang=js"
export * from "./CyanoDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__